<div class="container">
    <div class="toolbar">
        <header>
            <h3>{{ 'edit-sidenav-header' | translate }}</h3>
        </header>
        <button
            type="button"
            class="btn btn-circle btn-ghost element-cancel"
            [attr.aria-label]="'a11y-close' | translate"
            (click)="resetActiveFile()"
        ></button>
    </div>
    <div class="image-container">
        @if (selectedFile$ | async; as selectedFile) {
            @if (selectedFile?.preview) {
                <button
                    type="button"
                    class="image"
                    [attr.aria-label]="'a11y-change-preview-image' | translate"
                    (click)="previewInput.click()"
                >
                    <img [src]="selectedFile.preview.url | sanitizer" alt="File preview" />
                </button>
            }
            @if (!selectedFile?.preview) {
                @if (!selectedFile?.metaInfo?.thumbnail) {
                    <button
                        type="button"
                        class="image-placeholder"
                        [attr.aria-label]="'a11y-add-preview-image' | translate"
                        (click)="previewInput.click()"
                    >
                        <i class="icon element-camera"></i>
                    </button>
                    <p>{{ 'upload-sidenav-add-preview' | translate }}</p>
                }
                @if (selectedFile?.metaInfo?.thumbnail; as preview) {
                    <button
                        type="button"
                        class="image"
                        [attr.aria-label]="'a11y-change-preview-image' | translate"
                        (click)="previewInput.click()"
                    >
                        <img [src]="preview + '?token=' + token | sanitizer" alt="File preview" />
                    </button>
                }
            }
        }
        <input type="file" #previewInput hidden (change)="addPreview(previewInput.files)" [multiple]="false" />
    </div>
    <div class="description-container">
        <form [formGroup]="uploadForm">
            @if (selectedFile$ | async; as selectedFile) {
                <div class="description-item">
                    <p>{{ 'upload-sidenav-filename' | translate }}:</p>
                    @if (selectedFile?.file) {
                        <div class="filename">
                            {{ selectedFile?.file.name }}
                        </div>
                    }
                    @if (!selectedFile?.file) {
                        <div class="filename">
                            {{ selectedFile?.name }}
                        </div>
                    }
                    <div class="change-file-container">
                        <button type="button" class="btn btn-secondary" (click)="fileInput.click()">
                            {{ 'upload-sidenav-change-file-button' | translate }}
                        </button>
                    </div>
                    <input type="file" #fileInput hidden (change)="addFile($event)" [multiple]="false" />
                </div>
                <!-- Folder start -->
                <div class="description-item">
                    <p>{{ 'upload-sidenav-folder' | translate }}:</p>
                    @if ((driveData?.controls)['orgUnit']) {
                        <div class="folders" [formGroup]="driveData">
                            <p>{{ 'main-sidenav-all-templates' | translate }}</p>
                            <si-select
                                multi
                                [ariaLabel]="'upload-sidenav-orgunit' | translate"
                                [options]="orgUnitOptions$ | async"
                                [placeholder]="'upload-sidenav-orgunit' | translate"
                                formControlName="orgUnit"
                            ></si-select>
                            <input
                                type="number"
                                class="form-control"
                                [attr.aria-label]="'upload-sidenav-priority' | translate"
                                [placeholder]="'upload-sidenav-priority' | translate"
                                formControlName="filePriority"
                            />
                            @if (foldersData?.length >= 1) {
                                <button
                                    type="button"
                                    class="btn btn-circle btn-sm btn-ghost element-delete"
                                    [attr.aria-label]="'a11y-delete' | translate"
                                    (click)="removeDrive()"
                                ></button>
                            }
                        </div>
                    }
                    @for (folder of foldersData?.controls; track folder; let i = $index) {
                        <div class="folders" formArrayName="parentFolders">
                            <ng-container [formGroupName]="i">
                                <p>{{ folder.get('name').value }}</p>
                                <si-select
                                    multi
                                    [ariaLabel]="'upload-sidenav-orgunit' | translate"
                                    [options]="orgUnitOptions$ | async"
                                    [placeholder]="'upload-sidenav-orgunit' | translate"
                                    formControlName="orgUnit"
                                ></si-select>
                                <input
                                    type="number"
                                    class="form-control"
                                    [attr.aria-label]="'upload-sidenav-priority' | translate"
                                    [placeholder]="'upload-sidenav-priority' | translate"
                                    formControlName="filePriority"
                                />
                            </ng-container>
                            @if (foldersData.controls.length > 1 || (driveData?.controls)['orgUnit']) {
                                <button
                                    type="button"
                                    class="btn btn-circle btn-sm btn-ghost element-delete"
                                    [attr.aria-label]="'a11y-delete' | translate"
                                    (click)="removeFolder(i)"
                                ></button>
                            }
                        </div>
                    }
                    <button
                        type="button"
                        class="btn btn-circle btn-sm btn-ghost element-plus"
                        [attr.aria-label]="'a11y-add' | translate"
                        (click)="addFolder()"
                    ></button>
                </div>
                <!-- Folder end -->
                <hr />
                <div class="title-accordion">
                    <si-accordion>
                        <si-collapsible-panel [heading]="'upload-sidenav-title' | translate">
                            <div class="description-item">
                                @for (titleFormGroup of titlesData.controls; track titleFormGroup; let i = $index) {
                                    <div class="title-container" formArrayName="titles">
                                        <ng-container [formGroupName]="i">
                                            <si-select
                                                class="title-lang"
                                                [ariaLabel]="'upload-sidenav-language' | translate"
                                                [options]="languageSelectOptions"
                                                placeholder="Sprache"
                                                formControlName="language"
                                            ></si-select>
                                            <input
                                                class="form-control title-formfield"
                                                type="text"
                                                [attr.aria-label]="'upload-sidenav-title' | translate"
                                                [placeholder]="'upload-sidenav-title-placeholder' | translate"
                                                name="title"
                                                formControlName="text"
                                            />
                                        </ng-container>
                                        @if (i > 0) {
                                            <button
                                                type="button"
                                                class="btn btn-circle btn-sm btn-ghost element-delete"
                                                [attr.aria-label]="'a11y-delete' | translate"
                                                (click)="removeTitle(i)"
                                            ></button>
                                        }
                                    </div>
                                }
                                <button
                                    type="button"
                                    class="btn btn-circle btn-sm btn-ghost element-plus"
                                    [attr.aria-label]="'a11y-add' | translate"
                                    (click)="addTitle()"
                                ></button>
                            </div>
                        </si-collapsible-panel>
                        <si-collapsible-panel [heading]="'upload-sidenav-subtitle' | translate">
                            <div class="description-item">
                                @for (titleFormGroup of subtitlesData.controls; track titleFormGroup; let i = $index) {
                                    <div class="subtitle-container" formArrayName="subtitle">
                                        <ng-container [formGroupName]="i">
                                            <si-select
                                                class="title-lang"
                                                [ariaLabel]="'upload-sidenav-language' | translate"
                                                [options]="languageSelectOptions"
                                                placeholder="Sprache"
                                                formControlName="language"
                                            ></si-select>
                                            @if (i > 0) {
                                                <button
                                                    type="button"
                                                    class="btn btn-circle btn-sm btn-ghost element-delete"
                                                    [attr.aria-label]="'a11y-delete' | translate"
                                                    (click)="removeSubtitle(i)"
                                                ></button>
                                            }
                                            <textarea
                                                rows="4"
                                                class="form-control title-formfield"
                                                [attr.aria-label]="'upload-sidenav-subtitle' | translate"
                                                [placeholder]="'upload-sidenav-subtitle-placeholder' | translate"
                                                name="subtitle"
                                                formControlName="text"
                                            ></textarea>
                                        </ng-container>
                                    </div>
                                }
                                <button
                                    type="button"
                                    class="btn btn-circle btn-sm btn-ghost element-plus"
                                    [attr.aria-label]="'a11y-add' | translate"
                                    (click)="addSubtitle()"
                                ></button>
                            </div>
                        </si-collapsible-panel>
                    </si-accordion>
                </div>
                <hr />
                <div class="description-item">
                    <p>{{ 'upload-sidenav-author' | translate }}:</p>
                    <input
                        class="form-control"
                        type="text"
                        [attr.aria-label]="'upload-sidenav-author' | translate"
                        [placeholder]="'upload-sidenav-author-placeholder' | translate"
                        name="author"
                        formControlName="author"
                    />
                </div>
                <div class="description-item">
                    <p>{{ 'upload-sidenav-version' | translate }}:</p>
                    <input
                        class="form-control"
                        type="text"
                        [attr.aria-label]="'upload-sidenav-version' | translate"
                        [placeholder]="'upload-sidenav-version-placeholder' | translate"
                        name="version"
                        formControlName="version"
                    />
                </div>
                <div class="description-item">
                    <p>{{ 'upload-sidenav-language' | translate }}:</p>
                    <si-select
                        multi
                        [ariaLabel]="'upload-sidenav-language' | translate"
                        [options]="languageSelectOptions"
                        [placeholder]="'upload-sidenav-language-placeholder' | translate"
                        formControlName="language"
                    ></si-select>
                </div>
            }
        </form>
    </div>
    <div class="action-container">
        <si-loading-button
            buttonClass="btn btn-primary"
            [loading]="(loading$ | async) ?? false"
            [disabled]="uploadForm.invalid || (loading$ | async)"
            (click)="change()"
        >
            {{ 'upload-sidenav-change-button' | translate }}
        </si-loading-button>
    </div>
</div>

<ng-template #myUnitFolder>
    <div class="folders">
        {{ 'main-sidenav-all-templates' | translate }}
    </div>
</ng-template>
